import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsContractAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const coverProcessId = control.get('coverProcessId')!.value;
	const documentTypeArray = ['EGD020', 'EGD022', 'EGD025', 'EGD028', 'EGD030', 'EGD031'];

	return !coverProcessId && !!documentType && documentCategory === 'EGD09'  && !documentTypeArray.includes(documentType) ?
		{ checkDocCategoryIsContractAndDocTypeAllowedFlag: true } : null;

};
